import axios from 'axios';

import { DEFAULT_AXIOS_CONFIG } from './axiosConfig';

const instance = axios.create(DEFAULT_AXIOS_CONFIG);

export default instance;
